<template>
    <div>
    </div>
  </template>
  <script>
  import { useRoute } from 'vue-router';
  import { watch } from 'vue';
  
  export default {
    setup() {
      const route = useRoute();
      const excludedViews = ['InitializeId',
      'Initialize', 
      'LogoutInactivity', 
      'UnAutorized', 
      'Transmission', 
      'Information', 
      'Qualification',
      'EmployerContact',
      'Plans'];
  
      watch(
        () => route.name,
        (currentView) => {
            if(!excludedViews.includes(currentView) && 
            (localStorage.getItem('TP') === 'false' || localStorage.getItem('TP') === null) &&
            localStorage.getItem('FTDP') === 'true')
            {
                location.replace(process.env.VUE_APP_Front + "UnAutorized");
            }
            })           
        }   
    }
  </script>